<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <!-- <topPiece></topPiece> -->
      <div class="container">
        <div class="content_wrap" v-for="(item, index) in list" :key="index">
          <!-- type 1 有箭头的按钮 2 有背景色的按钮 3有图标的标题 4标题左侧红色框 -->
          <template v-if="type == 1">
            <newTitle
              v-if="index == 0"
              :title="langSet == 'cn' ? item.name : item.name_en"
            ></newTitle>
            <template v-else>
              <titleConfig
                v-if="
                  (item.name && langSet == 'cn') ||
                  (item.name_en && langSet == 'en')
                "
                :title="langSet == 'cn' ? item.name : item.name_en"
                :type="type == 3 ? 3 : 2"
              ></titleConfig>
            </template>
            <div
              class="main_content"
              :class="item.imgs.length == 1 ? 'flex flex_items_center' : ''"
            >
              <div
                class="img"
                v-if="item.imgs.length > 0"
                :class="
                  item.imgs.length > 1
                    ? 'img_wrap flex flex_content_sb'
                    : 'img_one'
                "
              >
                <img
                  v-for="(_item, _index) in item.imgs"
                  :key="_index"
                  class="content_img"
                  :src="_item"
                  alt=""
                />
              </div>
              <div>
                <div
                  v-html="langSet == 'cn' ? item.content : item.content_en"
                ></div>
                <div
                  class="button_image"
                  v-if="item.button_image"
                  :class="
                    type == 1
                      ? 'button_type flex flex_items_center flex_content_center'
                      : 'button_type2'
                  "
                  @click="toLink(item)"
                >
                  {{
                    langSet == "cn" ? item.button_image : item.button_image_en
                  }}
                  <img
                    :src="require('../../assets/imgs/icon_wright.png')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="type == 3">
            <newTitle
              v-if="index == 0"
              :title="langSet == 'cn' ? item.name : item.name_en"
            ></newTitle>
            <template v-else>
              <titleConfig
                v-if="
                  (item.name && langSet == 'cn') ||
                  (item.name_en && langSet == 'en')
                "
                :title="langSet == 'cn' ? item.name : item.name_en"
                :type="type == 3 ? 3 : 2"
              ></titleConfig>
            </template>
            <div
              class="main_content flex flex_items_center"
              :class="item.imgs.length == 1 ? 'main_second_type' : ''"
            >
              <div class="img" v-if="item.imgs.length > 0">
                <img
                  v-for="(_item, _index) in item.imgs"
                  :key="_index"
                  class="content_img"
                  :src="_item"
                  alt=""
                />
              </div>
              <div>
                <div
                  v-html="langSet == 'cn' ? item.content : item.content_en"
                ></div>
                <div
                  class="button_image button_type2 button_type3"
                  v-if="
                    (item.button_image && langSet == 'cn') ||
                    (item.button_image_en && langSet == 'en')
                  "
                  @click="toLink(item)"
                >
                  {{
                    langSet == "cn" ? item.button_image : item.button_image_en
                  }}
                  <img
                    v-if="type == 1"
                    :src="require('../../assets/imgs/icon_wright.png')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="type == 4">
            <titleConfig
              v-if="index == 0"
              :title="langSet == 'cn' ? item.name : item.name_en"
              type="2"
              style="margin-bottom: 20px"
            ></titleConfig>
            <template v-else>
              <div v-if="item.name_en" class="title_h2">
                {{ langSet == "cn" ? item.name : item.name_en }}
              </div>
            </template>
            <div
              class="main_content flex flex_items_center"
              :class="item.imgs.length == 1 ? 'main_second_type' : ''"
              v-if="item.content_en"
              style="padding: 20px 0 40px"
            >
              <div class="img" v-if="item.imgs.length > 0">
                <img
                  v-for="(_item, _index) in item.imgs"
                  :key="_index"
                  class="content_img"
                  :src="_item"
                  alt=""
                />
              </div>
              <div class="content_type_wrap">
                <div
                  class="content_type img_inline"
                  v-html="langSet == 'cn' ? item.content : item.content_en"
                ></div>
                <div
                  class="button_image button_type2 button_type3"
                  v-if="
                    (item.button_image && langSet == 'cn') ||
                    (item.button_image_en && langSet == 'en')
                  "
                  @click="toLink(item)"
                >
                  {{
                    langSet == "cn" ? item.button_image : item.button_image_en
                  }}
                  <img
                    v-if="type == 1"
                    :src="require('../../assets/imgs/icon_wright.png')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <newTitle
              v-if="index == 0"
              style="margin-bottom: 10px;"
              :title="langSet == 'cn' ? item.name : item.name_en"
            ></newTitle>
            <template v-else>
              <titleConfig
                v-if="
                  (item.name && langSet == 'cn') ||
                  (item.name_en && langSet == 'en')
                "
                :title="langSet == 'cn' ? item.name : item.name_en"
                :type="type == 3 ? 3 : 2"
              ></titleConfig>
            </template>
            <div
              v-if="item.imgs.length > 0 || (langSet == 'cn' && item.content) || ( langSet != 'cn' &&  item.content_en) || (item.button_image && langSet == 'cn') ||
                    (item.button_image_en && langSet == 'en')"
              class="main_content flex flex_items_center"
              :class="item.imgs.length == 1 ? 'main_second_type' : ''"
            >
              <div class="img" v-if="item.imgs.length > 0">
                <img
                  v-for="(_item, _index) in item.imgs"
                  :key="_index"
                  class="content_img"
                  :src="_item"
                  alt=""
                />
              </div>
              <div>
                <div
                  v-html="langSet == 'cn' ? item.content : item.content_en"
                ></div>
                <div
                  class="button_image"
                  v-if="
                    (item.button_image && langSet == 'cn') ||
                    (item.button_image_en && langSet == 'en')
                  "
                  :class="
                    type == 1
                      ? 'button_type flex flex_items_center flex_content_center'
                      : 'button_type2'
                  "
                  @click="toLink(item)"
                >
                  {{
                    langSet == "cn" ? item.button_image : item.button_image_en
                  }}
                  <img
                    v-if="type == 1"
                    :src="require('../../assets/imgs/icon_wright.png')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
// import topPiece from "@/components/topPiece.vue";
import titleConfig from "@/components/title.vue";
import newTitle from "@/components/new_title.vue";
import { webAbout } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    //topPiece,
    newTitle,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      list: [],
      id: 0,
      type: "",
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    //25.6.10 获取主办方内容 dxm
    // 1:展会介绍
    // 2:主办方
    // 3:观众参展
    // 4:住宿信息
    // 5:到达场馆
    // 6:口腔大会
    // 7:展商参展
    this.getWebAbout(this.id);
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getWebAbout(type) {
      let data = {
        type,
      };
      const res = await webAbout(data);
      let newArray;
      if (this.langSet == "cn") {
        newArray = res.data.lists.filter(
          (item) => item && (item.name || item.button_image || item.content)
        );
      } else {
        newArray = res.data.lists.filter(
          (item) =>
            item && (item.name_en || item.button_image_en || item.content_en)
        );
      }
      this.list = newArray;
    },
    toLink(item) {
      if (item.button_type == "跳转外链") {
        window.open(
          this.langSet == "cn" ? item.button_url : item.button_url_en,
          "_blank"
        );
      } else {
        this.$router.push({
          path: this.langSet == "cn" ? item.button_url : item.button_url_en,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  .title_h2 {
    font-size: 24px;
    padding-left: 15px;
    font-weight: bold;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      background: #e62344;
      transform: translateY(-50%);
    }
  }
  .content_type_wrap {
    width: 100%;
    .content_type {
      width: 100%;
    }
  }

  .main_content {
    padding: 40px 0 60px;
    font-size: 18px;
    color: #000;
    line-height: 28px;
    .img_one {
      width: 620px;
      margin-right: 40px;
      .content_img {
        width: 620px;
      }
    }
    .img_wrap {
      margin-bottom: 30px;
      .content_img {
        width: calc((100% - 40px) / 2);
        margin-right: 40px;
      }
    }
    .button_image {
      width: 226px;
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      text-align: center;
      margin-top: 30px;
      padding: 0 15px;
      cursor: pointer;
    }
    .button_type {
      height: 50px;
      line-height: 50px;
      background: #cf121b;
      border-radius: 40px;
      // background: url("../../assets/imgs/button_bg.png") no-repeat;
      // background-size: 100% 100%;
      img {
        width: 25px;
        height: 25px;
        margin-left: 17px;
      }
    }
    .button_type2 {
      width: 480px;
      height: 68px;
      line-height: 68px;
      margin-left: 70px;
      background: url("../../assets/imgs/btn_bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .button_type3 {
      width: 380px;
      margin: 30px auto 0;
    }
  }
  .main_second_type {
    .content_img {
      width: 300px;
      margin-right: 30px;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .content_wrap {
    .main_content {
      .img_one {
        width: 450px;
        .content_img {
          width: 450px;
        }
      }
      .img_wrap {
        margin-bottom: 30px;
        .content_img {
          width: calc((100% - 40px) / 2);
          margin-right: 40px;
        }
      }
      .button_image {
        margin-top: 30px;
        cursor: pointer;
      }
      .button_type {
        height: 64px;
        line-height: 64px;
      }
      .button_type2 {
        width: 380px;
        height: 58px;
        line-height: 58px;
        margin-left: 70px;
      }
    }
    .main_second_type {
      .content_img {
        width: 300px;
        margin-right: 30px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    .main_content {
      display: block;
      font-size: 0.27rem;
      line-height: 0.42rem;
      padding: 0.38rem 0 1.15rem;
      .content_img {
        width: 3.08rem;
        margin-right: 0;
        margin-bottom: 0.38rem;
      }
      .img_one {
        width: 100%;
        .content_img {
          width: 100%;
        }
      }
      .button_image {
        width: 4.15rem;
        height: 1.08rem;
        margin-top: 0.29rem;
        img {
          margin-left: 5px;
        }
      }
      .button_type2 {
        width: auto;
        height: 1.15rem;
        font-size: 0.35rem;
        line-height: 1.15rem;
        margin: 1.15rem auto;
      }
      .img_wrap {
        display: block;
        margin-bottom: 30px;
        .content_img {
          width: 100%;
          margin-right: 0;
        }
      }
    }
  }
}
</style>